module.exports = __webpack_public_path__ + "static/media/shell-select.37adfa40.png";